'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardTasksTemplatesCtrl', ['$state', 'departments', 'dialog', 'Department', 'templates','$uibModal', require('./dashboardTasksTemplatesCtrl')]);
app.directive('templates', [require('./templatesDirective')]);
app.config(['$stateProvider', require('./dashboardTasksTemplatesConfig')]);
